import React, { Component } from 'react';
import { debounce, GetRequest } from '../../utils/util'
import { Toast, Input, Button, } from 'antd-mobile'
import Axios from "axios";
import './index.scss';
class rechangeSuccess extends Component {
    constructor(props) {
        super(props)
        this.state = {
            bagImg: require('../../assets/background-img.png'),
            projectId: "",
            accountId: "",
            telephone: "",
            amount: "",
            studentNo: ""
        }
        this.onSubmit = debounce(this.onSubmit, 1000)

    }
    componentDidMount() {
        document.title = ""
        let data = JSON.parse(GetRequest().data);
        this.setState({
            telephone: data.telephone,
            accountId: data.accountId,
            projectId: data.projectId,
            amount: data.amount,
            studentNo: data.studentNo,
        })
    }
    /**
      * 充值
      */
    onSubmit = () => {
        let url = "http://8.129.20.81:8898/shuwei/pay"
        let data = {
            telephone: this.state.telephone,
            accountId: this.state.accountId,
            projectId: this.state.projectId,
            amount: this.state.amount,
            studentNo: this.state.studentNo,
        }
        Axios({
            url,
            method: 'post',
            headers: {
                "Content-Type": "multipart/form-data"
            },
            processData: false,
            params: data,
        }).then(
            (response) => {
                if (response.data.errorCode === 0) {
                    window.location.href = response.data.data
                }
                Toast.clear()
            },
            (err) => {
                Toast.show({
                    content: '系统错误',
                })
            }
        );
    }
    input(e) {
        this.setState({
            studentNo: e.target.value
        })
    }
    render() {
        var { bagImg, telephone, amount } = this.state
        return (
            <div className='rechange-success-page' >
                <div className='header-img' style={{ backgroundImage: "url(" + bagImg + ")" }}></div>
                <div className='header-body'>
                    <div className='header-content'>
                        <label>充值手机号：</label>
                        <div>{telephone}</div>
                    </div>
                    <div className='header-content'>
                        <label>充值金额：</label>
                        <div>{amount}</div>
                    </div>
                    <div className='header-content'>
                        <label>学号：</label>
                        <Input onBlur={(e) => this.input(e)} placeholder='请输入学号' style={{ '--text-align': 'right' }} clearable type='number' />
                    </div>
                    <div className='change-footer-btn'>
                        <Button className='btn' onClick={() => this.onSubmit()}>充 值</Button>
                    </div>
                </div>

            </div>
        );
    }

}

export default rechangeSuccess;
